import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProfileSettings from './user/components/ProfileSettings';
import UserAndRoles from './user/components/team-collaboration/UserAndRoles';
import InfluencerProfileEdit from '../influencer/profile/profile-form';
import UserNotifications from './user/components/UserNotifications';

export function SettingsRoutes() {
    return (
        <Routes>
            <Route path="users/:id?" element={<UserAndRoles />} />
            <Route path="notifications" element={<UserNotifications />} />
            <Route path="edit/:id" element={<InfluencerProfileEdit />} />
            <Route path="/" element={<ProfileSettings />} />
            <Route path="*" element={<Navigate to="/settings" replace />} />
        </Routes>
    );
}
